module.exports = __webpack_public_path__ + "public/images/monster.a54defa719b6b28052c5f6f901270d0a.svg";